import { CloudUpload } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const UploadIcon = DeckardIconWrapper({ Icon: CloudUpload });
